<div class="flex flex-wrap flex-row video-container w-full h-auto">
    <div class="w-full flex justify-end p-1 overlay-button overlay-close-button">

        @if (!isAdClosed) {
        <button
            class="flex justify-center items-center bg-[#f1e9eb] text-blue-700 border border-white-700 rounded w-[2rem] h-[2rem]"
            (click)="onClickEvent($event , 'on_ad_closed')">X</button>
        }
    </div>
    <div class="w-full flex justify-end p-1 overlay-button overlay-skip-button">
        <button
            class="flex justify-center items-center bg-[#f1e9eb] text-blue-700 border border-white-700 rounded lg:w-[10rem] md:[10rem] sm:w-[17%] w-[30%] h-[2rem] "
            [class]="{'opacity-50' : media.currentTime < 5}" [disabled]="media.currentTime < 5"
            (click)="onClickEvent($event , 'on_ad_skip')">{{(5 - media.currentTime > 0 ? 5 - media.currentTime :
            0).toFixed()}} Skip</button>
    </div>

    <div class="w-full ">
        @if (isAdClosed) {
        <div class="skipped-cover" (click)="onClickEvent($event , 'on_ad_clicked')"></div>
        }
        <video class="w-full h-auto" #media autoplay (timeupdate)="onClickEvent($event , 'on_ad_progress')"
            (pause)="onClickEvent($event , 'on_ad_paused')" (playing)="onClickEvent($event , 'on_ad_resumed')"
            (error)="onClickEvent($event , 'on_ad_error')" muted (ended)="onClickEvent($event , 'on_ad_completed')"
            aria-disabled="true" (click)="onClickEvent($event , 'on_ad_clicked')">
            <source [src]="adData.ads[index].creative.assetUrl" type="video/mp4">
            <!-- <source src="movie.ogg" type="video/ogg"> -->
            Your browser does not support the video tag.
        </video>

    </div>

    <button hidden (click)="pauseVideo()" id="pause-button"></button>
    <button hidden (click)="playVideo()" id="play-button"></button>
</div>